import DeliveryService from "../DeliveryService"

const Order = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/orders'
        if (r != undefined) {
            url = '/orders?' + r
        }
        return DeliveryService.get(url)
    },
    get(ref) {
        return DeliveryService.get(`/console/orders/` + ref)
    },
    addOrder(data) {
        return DeliveryService.post(`/orders`, data)
    },
    updateStatus(orderId, data) {
        return DeliveryService.post(`/orders/` + orderId + `/update/status`, data)
    },
    updateDatetime(ref, data) {
        return DeliveryService.post(`/console/orders/` + ref + `/update/datetime`, data)
    },
    getPayment(ref) {
        return DeliveryService.get(`/console/orders/` + ref + `/payment`)
    },
    requestDriver(orderId, data) {
        return DeliveryService.post(`/console/orders/` + orderId + `/driver-request`, data)
    },
    cancelDriver(orderId) {
        return DeliveryService.post(`/console/orders/` + orderId + `/driver-cancel`, null)
    },
    getDriver(orderId) {
        return DeliveryService.get(`/console/orders/` + orderId + `/driver`)
    },
    capturePayment(orderId) {
        return DeliveryService.post(`/orders/` + orderId + `/payment/capture`)
    },
    refundPayment(orderId) {
        return DeliveryService.post(`/orders/` + orderId + `/payment/refund`)
    },
    /*
    captureCard(orderId, data) {
        return DeliveryService.post(`/orders/` + orderId + `/update/status`, data)
    }
    */
}

export default Order